import { NgModule } from '@angular/core';

import { TherapiesPipe } from './therapies-pipe';
import { TherapyIconPipe } from './therapy-icon-pipe';
import { TherapyPipe } from './therapy-pipe';

@NgModule({
  declarations: [TherapyPipe, TherapiesPipe, TherapyIconPipe],
  exports: [TherapyPipe, TherapiesPipe, TherapyIconPipe],
  providers: [TherapyIconPipe],
})
export class TherapyPipesModule {}
